import { Card, Skeleton } from "@mui/material";
import { useSelector } from "react-redux";

const GraphicList = () => {
  const theme = useSelector((state) => state.theme.myTheme);

  return (
    <Card className="pa-3 rounded-lg">
      <div>
        <Skeleton height={35} />
        <Skeleton width={150} />
        <div className="mt-2">
          <Skeleton variant="rounded" height={320} />
        </div>
        <div className="my-3">
          <hr style={{ border: `1px solid ${theme.lighten}` }} />
        </div>
        <div className="mt-2">
          <div className="d-flex gap-3 align-center mt-2">
            <Skeleton variant="rounded" width={50} height={50} />
            <div className="grow">
              <Skeleton width={150} />
              <div className="d-flex gap-2 align-center justify-space-between">
                <Skeleton width={180} />
                <Skeleton width={30} />
              </div>
            </div>
          </div>
          <div className="d-flex gap-3 align-center mt-2">
            <Skeleton variant="rounded" width={50} height={50} />
            <div className="grow">
              <Skeleton width={150} />
              <div className="d-flex gap-2 align-center justify-space-between">
                <Skeleton width={180} />
                <Skeleton width={30} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Card>
  );
};

export { GraphicList };
